import { useEffect, useState } from "react";
import { Field, Formik } from "formik";
import { Row, Col, Card, Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import es from "react-phone-input-2/lang/es.json";
import DatePicker from "react-datepicker";
import { getTokenExternal } from "../../../utils/getTokenExternal";
import Get from "../../../api/Get";
import {
  ACCOUNT_CONF_MESSAGES_GET_BY_ID,
  ACCOUNT_SETTING_GET_BY_ID,
  COUNTRY_ACTIVE_ALL,
  GET_EPS,
  GET_LOCALIDADES,
  GET_OCUPACION,
  GET_PROPERTY_TYPES,
  GET_ROAD_TYPE,
  MUNICIPIO_LIST,
  PACIENTE_BUSCAR,
  PARTNER_GET_ACTIVE_SIN_TOKEN,
  STATES_LIST,
  TIPO_DOCUMENTO_PACIENTE_COLOMBIA,
} from "../../../api/Routes";
import { checkFieldValidation } from "../../../utils/checkFieldValidation";
import Post from "../../../api/Post";
import { id } from "date-fns/locale";
import moment from "moment";

export const getTipoDocumento = (value, tipoDocumentoOpt) => {
  let arr = tipoDocumentoOpt
    .filter((el) => el.code === "AS" || el.code === "MS")
    .map((e) => e.id);
  return arr.includes(parseInt(value));
};
export const getLengthDN = (code) => {
  switch (code.toUpperCase()) {
    case "CE":
      return 12;
    case "CD":
    case "PA":
    case "SC":
      return 16;
    case "PE":
      return 15;
    case "RC":
    case "TI":
      return 11;
    case "CN":
      return 9;
    case "MS":
      return 12;
    default:
      return 10;
  }
};
async function fetchNumeroDocumento(documento, idTD, access_token) {
  if (documento && idTD) {
    let result = [];
    const data = {
      documentNumber: documento,
      identityDocumentType: {id: idTD},
    };
    const response = await Post({
      url: PACIENTE_BUSCAR,
      data: data,
      access_token: access_token,
      header: true,
    });
    return 1
    // if (!response.data.state) {
    //   return [];
    // }
    //   } else {
    //     result.push(response.data.data);
    //     return result;
    //   }
    // } else {
    //   return [];
    // }
  }
}

const genderOpt = [
  {
    id: "Female",
    name: "Femenino",
  },
  {
    id: "Male",
    name: "Masculino",
  },
  {
    id: "NotSpecified",
    name: "No especificado",
  },
];
const tipoPlanOpt = [
  {
    id: "PLUS",
    name: "Plus",
  },
  {
    id: "INTEGRAL",
    name: "Integral",
  },
];
//['O-', 'O+', 'A-', 'A+', 'AB-', 'AB+', 'B+', 'B-', 'Desconocido']
const tipoSangreOpt = [
  { id: "O-", name: "O-" },
  { id: "O+", name: "O+" },
  { id: "A-", name: "A-" },
  { id: "A+", name: "A+" },
  { id: "AB-", name: "AB-" },
  { id: "AB+", name: "AB+" },
  { id: "B-", name: "B-" },
  { id: "B+", name: "B+" },
  { id: "Desconocido", name: "Desconocido" },
];
const ClbForm = ({
  classTop = "",
  data,
  setData,
  setCurrentScreen,
  setConfiguration,
}) => {
  const { t } = useTranslation();
  const enableFieldConsulta =
    data.source === "autoagendamientovardi" ||
    data.source === "autoagendamientoappallianz" ||
    data.source === "flujoallianz" ||
    data.source === "autoagendamientonuevoeps"
      ? false
      : true;
  const [fieldSettings, setFieldSettings] = useState([]);

  //options for selects
  const [options, setOptions] = useState({
    tipoDocumentoOpt: [],
    tipoPacienteOpt: [],
    ocupacionOpt: [],
    genderOpt: genderOpt,
    tipoPlanOpt: tipoPlanOpt,
    epsOpt: [],
    tipoSangreOpt: tipoSangreOpt,
    countryOpt: [],
    countryBirthOpt: [],
    municipioOpt: [],
    stateOpt: [],
    roadTypeOpt: [],
    localidadOpt: [],
    propertyTypeOpt: [],
  });
  //console.log(options)

  //utils to use in a few places
  const [utils, setUtils] = useState({
    hasLength: 10,
    disbaledInput: true,
    openAvisoLegal: false,
    openModalTitular: false,
    tipoDocumentModal: {
      id: "",
    },
    documentModal: "",
    errorModalTitular: false,
    openModalEncontroTitular: false,
    textModalTitular:
      "Sr(a) usuario por favor verifique la información del formulario, si requiere actualizar algún campo edítelo con la información correcta antes de continuar",
  });

  useEffect(() => {
    async function getFields() {
      try {
        const tokenObj = await getTokenExternal(
          data.patient.company
            ? data.patient.company
            : data.patient.account.partner.company
        );
        if (tokenObj.status === 200) {
          const { access_token } = tokenObj.data;
          const response = await Get({
            url: `${ACCOUNT_SETTING_GET_BY_ID}/${data.patient.account.id}`,
            access_token: access_token,
          });
          if (response.data.state) {
            setFieldSettings(response.data?.data?.formSettingsDTOList || []);
          }

          const responseConf = await Get({
            url: `${ACCOUNT_CONF_MESSAGES_GET_BY_ID}/${data.patient.account.id}`,
            access_token: access_token,
          });
          if (responseConf.data.state) {
            setConfiguration({
              approvedServiceText:
                responseConf.data.data?.approvedServiceText || "",
              informationPatientStep1:
                responseConf.data.data?.informationPatientStep1 || "",
              informationTelemedicine:
                responseConf.data.data?.informationTelemedicine || "",
              informedConsent: responseConf.data.data?.informedConsent || "",
              urlImage: responseConf.data.data?.urlImage || "",
              colorFont: responseConf.data.data?.colorFont || "",
              fontSize: responseConf.data.data?.fontSize || "",
              paymentText: responseConf.data.data?.paymentText || "",
            });
          }

          //algunas opciones para selects que necesitan token
          //get ocupaciones
          try {
            const responseOcupacion = await Get({
              url: GET_OCUPACION,
              access_token: access_token,
            });
            setOptions((prev) => ({
              ...prev,
              ocupacionOpt: responseOcupacion.data.data.response,
            }));
          } catch (error) {}
          try {
            const responseOcupacion = await Get({
              url: GET_EPS,
              access_token: access_token,
            });
            setOptions((prev) => ({
              ...prev,
              epsOpt: responseOcupacion.data.data.response,
            }));
          } catch (error) {}
          try {
            const responseLocalidad = await Get({
              url: GET_LOCALIDADES,
              access_token: access_token,
            });
            setOptions((prev) => ({
              ...prev,
              localidadOpt: responseLocalidad.data.data.response,
            }));
          } catch (error) {}
          //
          try {
            const responseLocalidad = await Get({
              url: GET_PROPERTY_TYPES,
              access_token: access_token,
            });
            setOptions((prev) => ({
              ...prev,
              propertyTypeOpt: responseLocalidad.data.data.response,
            }));
          } catch (error) {}
          //road types
          try {
            const responseRoadTypes = await Get({
              url: GET_ROAD_TYPE,
              access_token: access_token,
            });
            setOptions((prev) => ({
              ...prev,
              roadTypeOpt: responseRoadTypes.data.data.response,
            }));
          } catch (error) {}
        }
      } catch (error) {}
    }
    getFields();
  }, []);

  //utils para selects
  useEffect(() => {
    const getApiRequest = async () => {
      //tipos de pacientes
      try {
        const responseTipoPaciente = await Get({
          url: `${PARTNER_GET_ACTIVE_SIN_TOKEN}/${data.patient.account.id}`,
          noToken: true,
        });
        setOptions((prev) => ({
          ...prev,
          tipoPacienteOpt: responseTipoPaciente.data.data.response,
        }));
      } catch (error) {}
      //
      try {
        const responseCountries = await Get({
          url: COUNTRY_ACTIVE_ALL,
          noToken: true,
        });
        setOptions((prev) => ({
          ...prev,
          countryOpt: responseCountries.data.data.response,
          countryBirthOpt: responseCountries.data.data.response,
        }));
      } catch (error) {}
      //tipo documento
      try {
        const responseTipoDocumento = await Get({
          url: TIPO_DOCUMENTO_PACIENTE_COLOMBIA,
          noToken: true,
        });
        setOptions((prev) => ({
          ...prev,
          tipoDocumentoOpt: responseTipoDocumento.data,
        }));
      } catch (error) {}
    };
    getApiRequest();
  }, []);

  //si cambia el pais
  const [idCountry, setIdCountry] = useState(
    data.patient.country?.id ? data.patient.country.id : data.patient.country
  );
  useEffect(() => {
    const fecthApi = async () => {
      try {
        const response = await Get({
          url: `${STATES_LIST}/${idCountry}`,
          noToken: true,
        });
        setOptions((prev) => ({
          ...prev,
          stateOpt: response.data.data.response,
        }));
      } catch (error) {
        setOptions((prev) => ({
          ...prev,
          stateOpt: [],
        }));
      }
    };
    if (idCountry) {
      fecthApi();
    } else {
      setOptions((prev) => ({
        ...prev,
        stateOpt: [],
      }));
    }
  }, [idCountry]);

  //si cambia el estado
  const [idEstado, setIdEstado] = useState(
    data.patient.state?.id ? data.patient.state.id : data.patient.state
  );
  useEffect(() => {
    const fecthApi = async () => {
      try {
        const response = await Get({
          url: `${MUNICIPIO_LIST}/${idEstado}`,
          noToken: true,
        });
        setOptions((prev) => ({
          ...prev,
          municipioOpt: response.data.data.response,
        }));
      } catch (error) {
        setOptions((prev) => ({
          ...prev,
          municipioOpt: [],
        }));
      }
    };
    if (idEstado) {
      fecthApi();
    } else {
      setOptions((prev) => ({
        ...prev,
        municipioOpt: [],
      }));
    }
  }, [idEstado]);

  const shemaValidate = Yup.object().shape({
    name: Yup.string().required(t("Camporequerido")),
    lastName: Yup.string().required(t("Camporequerido")),
    gender: checkFieldValidation("gender", fieldSettings)?.required
      ? Yup.string().required(t("Camporequerido"))
      : Yup.string().notRequired(),
    dateOfBirthday: Yup.string().required(t("Camporequerido")),
    phoneNumber: Yup.string().required(t("Camporequerido")),
    phoneNumber2: Yup.string().required(t("Camporequerido")),
    email: Yup.string()
      .email(t("Correoinvalido"))
      .matches(/^(?!prueba@prueba.com\b)/i, "Este correo no se puede usar")
      .required(t("Camporequerido")),
    identityDocumentType: Yup.object().shape({
      id: Yup.string().required(t("Camporequerido")),
    }),
    documentNumber: Yup.string().when("identityDocumentType.id", {
      is: (value) => getTipoDocumento(value, options.tipoDocumentoOpt),
      then: Yup.string().required(t("Camporequerido")),
      otherwise: Yup.string()
        .required(t("Camporequerido"))
        .min(5, `Debe tener una longitud mínima de 5 caracteres`)
        .max(
          utils.hasLength,
          `Debe tener una longitud máxima de ${utils.hasLength} caracteres`
        ),
    }),
    country: Yup.object().shape({
      id: checkFieldValidation("country", fieldSettings)?.required
        ? Yup.string().required(t("Camporequerido"))
        : Yup.string().notRequired(),
    }),
    countryBirth: Yup.object().shape({
      id: checkFieldValidation("countryBirth", fieldSettings)?.required
        ? Yup.string().required(t("Camporequerido"))
        : Yup.string().notRequired(),
    }),
    // municipio: Yup.object().shape({
    //   id: Yup.string().required(t("Camporequerido")),
    // }),
    localidad: Yup.object().when("municipio", {
      is: (val) => {
        if (
          val &&
          parseInt(val.id) !== 2633 &&
          !checkFieldValidation("localidad", fieldSettings)?.required
        ) {
          return true;
        }
        return false;
      },
      then: Yup.object().shape({
        id: Yup.number().notRequired(),
      }),
      otherwise: Yup.object().shape({
        id: Yup.number().required(t("Camporequerido")),
      }),
    }),
    // state: Yup.object().shape({
    //   id: Yup.string().required(t("Camporequerido")),
    // }),
    ocupacion: Yup.object().shape({
      id: checkFieldValidation("ocupacion", fieldSettings)?.required
        ? Yup.string().required(t("Camporequerido"))
        : Yup.string().notRequired(),
    }),
    nationality: checkFieldValidation("nationality", fieldSettings)?.required
      ? Yup.string().required(t("Camporequerido"))
      : Yup.string().notRequired(),
    bloodType: checkFieldValidation("bloodType", fieldSettings)?.required
      ? Yup.string().required(t("Camporequerido"))
      : Yup.string().notRequired(),
    peso: checkFieldValidation("peso", fieldSettings)?.required
      ? Yup.number().required(t("Camporequerido")).positive(t("mayor_a_cero"))
      : Yup.number().positive(t("mayor_a_cero")),
    talla: checkFieldValidation("talla", fieldSettings)?.required
      ? Yup.number().required(t("Camporequerido")).positive(t("mayor_a_cero"))
      : Yup.number().positive(t("mayor_a_cero")),
    sintomas: Yup.string().required(t("Camporequerido")),
    aceptarTerminos: Yup.bool().oneOf(
      [true],
      t("aceptar_terminos_condiciones")
    ),
    patientRelationship: Yup.object().shape({
      id: checkFieldValidation("patientRelationship", fieldSettings)?.required
        ? Yup.string().required(t("Camporequerido"))
        : Yup.string().notRequired(),
    }),
    colombusAddress: Yup.object().shape({
      //   roadType: Yup.object().shape({
      //     id: Yup.string().required(t("Camporequerido")),
      //   }),
      //   streetField1: Yup.string().required(t("Camporequerido")),
      //   streetField2: Yup.string().required(t("Camporequerido")),
      //   streetField3: Yup.string().required(t("Camporequerido")),
      propertyTypeAdditional: checkFieldValidation(
        "propertyTypeAdditional",
        fieldSettings
      )?.required
        ? Yup.object()
            .shape({
              id: Yup.string().required(t("Camporequerido")),
            })
            .nullable()
        : Yup.object()
            .shape({
              id: Yup.string().notRequired(),
            })
            .nullable(),
      propertyNumber: checkFieldValidation(
        "propertyTypeAdditional",
        fieldSettings
      )?.required
        ? Yup.string().required(t("Camporequerido"))
        : Yup.string().notRequired(),
      propertyType: checkFieldValidation("propertyType", fieldSettings)
        ?.required
        ? Yup.object()
            .shape({
              id: Yup.string().required(t("Camporequerido")),
            })
            .nullable()
        : Yup.object()
            .shape({
              id: Yup.string().notRequired(),
            })
            .nullable(),
      unitNumber: checkFieldValidation("propertyType", fieldSettings)?.required
        ? Yup.string().required(t("Camporequerido"))
        : Yup.string().notRequired(),
    }),
    eps: Yup.object().shape({
      id: Yup.number().when("account.id", {
        is: (value) =>
          value === 144 &&
          !checkFieldValidation("eps", fieldSettings)?.required,
        then: Yup.string().notRequired(),
        otherwise: checkFieldValidation("eps", fieldSettings)?.required
          ? Yup.number().required(t("Camporequerido"))
          : Yup.number().notRequired(),
      }),
    }),
    tipoPlan: Yup.string().when("account", {
      is: (val) =>
        val &&
        parseInt(val.id) === 144 &&
        data.source === "autoagendamientonuevoeps",
      then: Yup.string().required(t("Camporequerido")),
      otherwise: Yup.string().notRequired(),
    }),
    titular: Yup.object().when("patientRelationship", {
      is: (val) => {
        if (
          val &&
          parseInt(val.id) !== 1 &&
          data.source === "autoagendamientovardi" &&
          checkFieldValidation("patientRelationship", fieldSettings)?.visible
        ) {
          return true;
        }
        return false;
      },
      then: Yup.object().shape({
        documentNumber: Yup.string().required(t("Camporequerido")),
      }),
      otherwise: Yup.object().shape({
        documentNumber: Yup.string().notRequired(),
      }),
    }),
    neighborhood: checkFieldValidation("neighborhood", fieldSettings)?.required
      ? Yup.string().required(t("Camporequerido"))
      : Yup.string().notRequired(),
  });

  const validarDocumento = () => {
    if (utils.documentModal && utils.tipoDocumentModal.id) {
      //setIsBusandoPaciente(true)
      setUtils((prev) => ({
        ...prev,
        errorModalTitular: false,
      }));
      try {
        async function fetchTokenExternal() {
          let response = await getTokenExternal({ id: 2 });
          if (response.data.access_token) {
            const resp = await fetchNumeroDocumento(
              utils.documentModal,
              utils.tipoDocumentModal.id,
              response.data.access_token
            );
            if (resp.length > 0) {
              setData((prev) => ({
                ...prev,
                patient: {
                  ...prev.patient,
                  titular: {
                    documentNumber: resp[0].documentNumber,
                    identityDocumentType: resp[0].identityDocumentType,
                  },
                },
              }));
            }
          }
          //setIsBusandoPaciente(false)
          setUtils((prev) => ({
            ...prev,
            openModalTitular: false,
          }));
        }
        fetchTokenExternal();
      } catch (error) {
        //setIsBusandoPaciente(false)
        console.log(error);
      }
    } else {
      setUtils((prev) => ({
        ...prev,
        errorModalTitular: true,
      }));
    }
  };

  const [idTipoDocumento, setIdTipoDocumento] = useState(null);
  const handleBlur = (e, error) => {
    if (e.target.value !== "" && error === undefined) {
      //setLoadPaciente(true)
      try {
        async function fetchTokenExternal() {
          let response = await getTokenExternal({ id: 2 });
          if (response.data.access_token) {
            //checamos el numero de documento
            const resp = await fetchNumeroDocumento(
              e.target.value,
              idTipoDocumento,
              response.data.access_token
            );
            if (resp.length > 0) {
              const findPatient = resp[resp.length - 1];
              //console.log(findPatient)
              let initColombusA = {
                id: "",
                roadType: findPatient.colombusAddress?.roadType ?? null,
                roadType_name:
                  findPatient.colombusAddress?.roadType?.name ?? "",
                streetField1: findPatient.colombusAddress?.streetField1 ?? "",
                streetField2: findPatient.colombusAddress?.streetField2 ?? "",
                streetField3: findPatient.colombusAddress?.streetField3 ?? "",
                propertyNumber:
                  findPatient.colombusAddress?.propertyNumber ?? "",
                propertyType: findPatient.colombusAddress?.propertyType ?? null,
                propertyTypeAdditional:
                  findPatient.colombusAddress?.propertyTypeAdditional ?? null,
                unitNumber: findPatient.colombusAddress?.unitNumber ?? "",
              };
              //console.log(findPatient)
              const patientFounded = {
                id: findPatient.id,
                name: findPatient.name.toUpperCase(),
                middleName: findPatient.middleName.toUpperCase() ?? "",
                seccondSurname: findPatient.seccondSurname.toUpperCase() ?? "",
                lastName: findPatient.lastName.toUpperCase() ?? "",
                gender: findPatient.gender ?? "",
                dateOfBirthday: findPatient.dateOfBirthday
                  ? new Date(moment(findPatient.dateOfBirthday, "DD-MM-YYYY"))
                  : "",
                nationality: findPatient.nationality,
                phoneNumber: findPatient.phone ?? "",
                phoneNumber2: findPatient.phone2 ?? "",
                email: findPatient.email,
                bloodType: findPatient.bloodType,
                ocupacion: findPatient?.ocupacion?.id ?? { id: "" },
                neighborhood: findPatient.neighborhood,
                identityDocumentType: findPatient?.identityDocumentType ?? {
                  id: "",
                },
                documentNumber: findPatient.documentNumber,
                country: findPatient?.country?.id ?? { id: "" },
                state: findPatient?.state?.id ?? null,
                municipio: findPatient?.municipio?.id ?? null,
                localidad: findPatient?.localidad?.id
                  ? findPatient?.localidad
                  : { id: "" },
                patientRelationship: findPatient.patientRelationshipDTO?.id ?? {
                  id: "",
                },
                countryBirth: findPatient?.countryBirth?.id ?? { id: "" },
                colombusAddress: initColombusA,
                eps: findPatient.eps?.id
                  ? {
                      id: parseInt(findPatient.eps?.id),
                      nombreEps: findPatient.eps?.name,
                    }
                  : { id: "" },
                tipoPlan: "",
                sintomas: "",
              };
              //console.log(patientFounded)

              setIdCountry(findPatient.country?.id ?? "");
              setIdEstado(findPatient.state?.id ?? "");
              setData((prev) => ({
                ...prev,
                patient: {
                  account: prev.patient.account,
                  aceptarTerminos: true,
                  ...patientFounded,
                },
              }));
              setUtils((prev) => ({
                ...prev,
                openModalEncontroTitular: true,
              }));
            } else {
              const patientNotFounded = {
                id: "",
                name: "",
                middleName: "",
                seccondSurname: "",
                lastName: "",
                gender: "",
                dateOfBirthday: "",
                nationality: "",
                phoneNumber: "",
                phoneNumber2: "",
                email: "",
                identityDocumentType: {
                  id:
                    options.tipoDocumentoOpt.find(
                      (e) => e.id === idTipoDocumento
                    )?.id ?? "",
                },
                documentNumber: e.target.value,
                bloodType: "",
                ocupacion: { id: "" },
                account: data.patient.account,
                neighborhood: "",
                country: { id: "" },
                state: null,
                municipio: null,
                localidad: { id: "" },
                patientRelationship: { id: "" },
                countryBirth: { id: "" },
                colombusAddress: {
                  id: "",
                  roadType: null,
                  streetField1: "",
                  streetField2: "",
                  streetField3: "",
                  propertyNumber: "",
                  propertyType: null,
                  propertyTypeAdditional: null,
                  unitNumber: "",
                },
                eps: {
                  id: "",
                  nombreEps: "",
                  codigo: "",
                },
                tipoPlan: "",
              };
              setData((prev) => ({
                ...prev,
                aceptarTerminos: true,
                patientNotFounded,
              }));
            }
            //setLoadPaciente(false)
            setUtils((prev) => ({
              ...prev,
              disbaledInput: false,
            }));
          }
        }
        fetchTokenExternal();
      } catch (error) {
        console.log(error);
      }
    }
  };
  return (
    <Row className={classTop}>
      <Col xs="12" md={{ span: 10, offset: 1 }}>
        <Card className="mt-2 mb-5 shadow-sm">
          <Card.Body>
            <Formik
              initialValues={{
                ...data.patient,
                patientRelationship: {
                  id: parseInt(data.patient.patientRelationship),
                },
                ocupacion: {
                  id: parseInt(data.patient.ocupacion),
                  nombreOcupacion:
                    options.ocupacionOpt.find(
                      (it) => it.id === parseInt(data.patient.ocupacion)
                    )?.nombreOcupacion ?? "",
                },
                country: data.patient.country.id
                  ? {
                      id: data.patient.country.id,
                      name: data.patient.country.name,
                    }
                  : {
                      id: data.patient.country,
                      name:
                        options.countryOpt.find(
                          (it) => it.id === data.patient.country
                        )?.name ?? "",
                    },
                countryBirth: data.patient.countryBirth.id
                  ? {
                      id: data.patient.countryBirth.id,
                      name: data.patient.countryBirth.name,
                    }
                  : {
                      id: data.patient.countryBirth,
                      name:
                        options.countryBirthOpt.find(
                          (it) => it.id === data.patient.countryBirth
                        )?.name ?? "",
                    },
                state: data.patient.state?.id
                  ? { id: data.patient.state.id, name: data.patient.state.name }
                  : {
                      id: data.patient.state,
                      name:
                        options.stateOpt.find(
                          (it) => it.id === data.patient.state
                        )?.name ?? "",
                    },
                municipio: data.patient.municipio?.id
                  ? {
                      id: data.patient.municipio.id,
                      dsMunDel: data.patient.municipio.dsMunDel,
                    }
                  : {
                      id: parseInt(data.patient.municipio),
                      dsMunDel:
                        options.municipioOpt.find(
                          (it) => it.id === data.patient.municipio
                        )?.dsMunDel ?? "",
                    },
              }}
              enableReinitialize
              validationSchema={shemaValidate}
              onSubmit={(values) => {
                console.log("submit");
                console.log(values);
                setData((prev) => ({
                  ...data,
                  patient: values,
                }));
                setCurrentScreen("clbEspecialidad");
              }}
            >
              {({
                errors,
                handleSubmit,
                setFieldValue,
                setFieldError,
                values,
              }) => (
                <Form onSubmit={handleSubmit}>
                  {console.log(errors)}
                  <h5 className="colorLink text-center mb-4">
                    Información del Paciente
                  </h5>
                  <Row>
                    <Col xs="12" md="6">
                      <Form.Group>
                        <Form.Label className="fw-medium">
                          {t("tipo_documento")} *
                        </Form.Label>
                        <Select
                          options={options.tipoDocumentoOpt.map((it) => ({
                            label: `${it.code}: ${it.name}`,
                            value: it.id,
                            code: it.code,
                            name: it.name,
                          }))}
                          value={
                            values.identityDocumentType?.id
                              ? {
                                  label: `${values.identityDocumentType.code}: ${values.identityDocumentType.name}`,
                                  value: values.identityDocumentType.id,
                                }
                              : null
                          }
                          onChange={(value) => {
                            console.log(value);
                            if (value) {
                              setIdTipoDocumento(value.value);
                              setFieldValue(
                                "identityDocumentType.id",
                                value.value
                              );
                              setFieldValue(
                                "identityDocumentType.name",
                                value.name
                              );
                              setFieldValue(
                                "identityDocumentType.code",
                                value.code
                              );
                              setUtils((prev) => ({
                                ...prev,
                                hasLength: getLengthDN(value.code),
                              }));
                            } else {
                              setIdTipoDocumento(null);
                              setFieldValue("identityDocumentType.id", "");
                              setUtils((prev) => ({
                                ...prev,
                                disbaledInput: true,
                              }));
                            }
                          }}
                          placeholder="Selecciona una opción"
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              height: "34px",
                              border: "1px solid #2A7EC3",
                              boxShadow: 0,
                              "&:hover": {
                                borderColor: "#2A7EC3",
                              },
                            }),
                          }}
                        />
                        {errors.identityDocumentType?.id && (
                          <div className="invalid-feedback d-block">
                            {errors.identityDocumentType.id}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="6">
                      <Form.Group>
                        <Form.Label
                          className="fw-medium"
                          htmlFor="documentNumber"
                        >
                          {t("documento_identidad")}{" "}
                        </Form.Label>
                        <Field
                          type="text"
                          className={`form-input ${
                            errors.documentNumber && "error"
                          }`}
                          name="documentNumber"
                          id="documentNumber"
                          onBlur={(e) => handleBlur(e, errors.documentNumber)}
                          disabled={
                            !values.identityDocumentType.id || data.noEdit
                          }
                        />
                        {errors.documentNumber && (
                          <div className="invalid-feedback d-block">
                            {errors.documentNumber}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    {checkFieldValidation("patientRelationship", fieldSettings)
                      ?.visible && (
                      <Col xs="12" md="4">
                        <Form.Group>
                          <Form.Label className="fw-medium">
                            Tipo paciente{" "}
                            {checkFieldValidation(
                              "patientRelationship",
                              fieldSettings
                            )?.required && "*"}
                          </Form.Label>
                          <Select
                            options={options.tipoPacienteOpt.map((it) => ({
                              label: it.name,
                              value: it.id,
                            }))}
                            value={
                              values.patientRelationship
                                ? {
                                    value: values.patientRelationship.id,
                                    label: values.patientRelationship.name,
                                  }
                                : null
                            }
                            onChange={(value) => {
                              if (value) {
                                setFieldValue(
                                  "patientRelationship.id",
                                  value.value
                                );
                                setFieldValue(
                                  "patientRelationship.name",
                                  value.label
                                );
                              } else {
                                setFieldValue("patientRelationship.id", "");
                              }
                            }}
                            placeholder="Selecciona una opción"
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                height: "34px",
                                border: "1px solid #2A7EC3",
                                boxShadow: 0,
                                "&:hover": {
                                  borderColor: "#2A7EC3",
                                },
                              }),
                            }}
                            isDisabled={utils.disbaledInput}
                          />
                          {errors.patientRelationship?.id && (
                            <div className="invalid-feedback d-block">
                              {errors.patientRelationship.id}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    )}
                    {values.patientRelationship &&
                      values.patientRelationship?.id?.toString() !== "1" &&
                      data.source === "autoagendamientovardi" && (
                        <Col xs="12" md="4">
                          <Form.Group>
                            <Form.Label
                              className="fw-medium"
                              htmlFor="titular.documentNumber"
                            >
                              Número de documento del titular{" "}
                            </Form.Label>
                            <Field
                              type="text"
                              className={`form-input ${
                                errors.titular?.documentNumber && "error"
                              }`}
                              name="titular.documentNumber"
                              id="titular.documentNumber"
                              disabled={utils.disbaledInput}
                            />
                            {errors.titular?.documentNumber && (
                              <div className="invalid-feedback d-block">
                                {errors.titular.documentNumber}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                      )}
                    <Col xs="12" md="4">
                      <Form.Group>
                        <Form.Label className="fw-medium">
                          {t("ocupacion")}
                        </Form.Label>
                        <Select
                          options={options.ocupacionOpt.map((it) => ({
                            label: it.nombreOcupacion,
                            value: it.id,
                          }))}
                          value={
                            values.ocupacion?.id
                              ? {
                                  value: values.ocupacion.id,
                                  label: values.ocupacion.nombreOcupacion,
                                }
                              : null
                          }
                          onChange={(value) => {
                            if (value) {
                              setFieldValue("ocupacion.id", value.value);
                              setFieldValue(
                                "ocupacion.nombreOcupacion",
                                value.label
                              );
                            } else {
                              setFieldValue("ocupacion.id", "");
                            }
                          }}
                          placeholder="Selecciona una opción"
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              height: "34px",
                              border: "1px solid #2A7EC3",
                              boxShadow: 0,
                              "&:hover": {
                                borderColor: "#2A7EC3",
                              },
                            }),
                          }}
                          isDisabled={utils.disbaledInput}
                        />
                        {errors.ocupacion?.id && (
                          <div className="invalid-feedback d-block">
                            {errors.ocupacion.id}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12" md="3">
                      <Form.Group>
                        <Form.Label className="fw-medium">Nombre *</Form.Label>
                        <Field
                          type="text"
                          className={`form-input text-uppercase ${
                            errors.name && "error"
                          }`}
                          name="name"
                          onChange={(e) => {
                            setFieldValue("name", e.target.value.toUpperCase());
                          }}
                          disabled={utils.disbaledInput || data.noEdit}
                        />
                        {errors.name && (
                          <div className="invalid-feedback d-block">
                            {errors.name}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="3">
                      <Form.Group>
                        <Form.Label className="fw-medium">
                          Segundo nombre{" "}
                        </Form.Label>
                        <Field
                          type="text"
                          className={`form-input text-uppercase`}
                          name="middleName"
                          onChange={(e) => {
                            setFieldValue(
                              "middleName",
                              e.target.value.toUpperCase()
                            );
                          }}
                          disabled={utils.disbaledInput || data.noEdit}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="3">
                      <Form.Group>
                        <Form.Label className="fw-medium">
                          Primer apellido *
                        </Form.Label>
                        <Field
                          type="text"
                          className={`form-input text-uppercase ${
                            errors.lastName && "error"
                          }`}
                          name="lastName"
                          onChange={(e) => {
                            setFieldValue(
                              "lastName",
                              e.target.value.toUpperCase()
                            );
                          }}
                          disabled={utils.disbaledInput || data.noEdit}
                        />
                        {errors.lastName && (
                          <div className="invalid-feedback d-block">
                            {errors.lastName}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="3">
                      <Form.Group>
                        <Form.Label className="fw-medium">
                          Segundo apellido
                        </Form.Label>
                        <Field
                          type="text"
                          className={`form-input text-uppercase`}
                          name="seccondSurname"
                          onChange={(e) => {
                            setFieldValue(
                              "seccondSurname",
                              e.target.value.toUpperCase()
                            );
                          }}
                          disabled={utils.disbaledInput || data.noEdit}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="6">
                      <Form.Group>
                        <Form.Label className="fw-medium">
                          {data.source === "autoagendamientoappallianz"
                            ? t("correo_electronico_cita")
                            : t("Correoelectronico")}{" "}
                          *
                        </Form.Label>
                        <Field
                          type="text"
                          className={`form-input ${errors.email && "error"}`}
                          name="email"
                          disabled={utils.disbaledInput || data.noEdit}
                        />
                        {errors.email && (
                          <div className="invalid-feedback d-block">
                            {errors.email}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="3">
                      <Form.Group>
                        <Form.Label className="fw-medium">
                          Teléfono *
                        </Form.Label>
                        {console.log(values.phoneNumber)}
                        <PhoneInput
                          containerClass="phone2"
                          inputClass={`form-input`}
                          buttonClass="btn-phone2"
                          countryCodeEditable={false}
                          enableSearch={true}
                          preferredCountries={["mx", "co"]}
                          disableSearchIcon={true}
                          localization={es}
                          value={values.phoneNumber ?? ""}
                          onChange={(phone, country, e, formattedValue) => {
                            setFieldValue("phoneNumber", phone);
                          }}
                          disabled={utils.disbaledInput}
                        />
                        {errors.phoneNumber && (
                          <div className="invalid-feedback d-block">
                            {errors.phoneNumber}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="3">
                      <Form.Group>
                        <Form.Label className="fw-medium">
                          Teléfono alternativo *
                        </Form.Label>
                        <PhoneInput
                          containerClass="phone2"
                          inputClass={`form-input`}
                          buttonClass="btn-phone2"
                          countryCodeEditable={false}
                          enableSearch={true}
                          preferredCountries={["mx", "co"]}
                          disableSearchIcon={true}
                          localization={es}
                          value={values.phoneNumber2 ?? ""}
                          onChange={(phone, country, e, formattedValue) => {
                            setFieldValue("phoneNumber2", phone);
                          }}
                          disabled={utils.disbaledInput}
                        />
                        {errors.phoneNumber2 && (
                          <div className="invalid-feedback d-block">
                            {errors.phoneNumber2}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    {checkFieldValidation("gender", fieldSettings)?.visible && (
                      <Col xs="12" md="4">
                        <Form.Group>
                          <Form.Label className="fw-medium">
                            {t("sexo")}
                          </Form.Label>
                          <Select
                            options={options.genderOpt.map((it) => ({
                              value: id.id,
                              label: it.name,
                            }))}
                            value={
                              values.gender
                                ? {
                                    value: values.gender,
                                    label: options.genderOpt.find(
                                      (it) => it.id === values.gender
                                    ).name,
                                  }
                                : null
                            }
                            onChange={(value) => {
                              setFieldValue("gender", value.value ?? "");
                            }}
                            placeholder="Selecciona una opción"
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                height: "34px",
                                border: "1px solid #2A7EC3",
                                boxShadow: 0,
                                "&:hover": {
                                  borderColor: "#2A7EC3",
                                },
                              }),
                            }}
                            isDisabled={utils.disbaledInput}
                          />
                          {errors.gender && (
                            <div className="invalid-feedback d-block">
                              {errors.gender}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    )}
                    <Col xs="12" md="4">
                      <Form.Group>
                        <Form.Label className="fw-medium">
                          {t("fecha_nacimiento")} *
                        </Form.Label>
                        <DatePicker
                          className={`form-input ${
                            errors.dateOfBirthday && "error"
                          }`}
                          selected={values.dateOfBirthday}
                          dateFormat="dd-MM-yyyy"
                          maxDate={new Date()}
                          onChange={(date) => {
                            if (date) {
                              setFieldValue("dateOfBirthday", date);
                            } else {
                              setFieldValue("dateOfBirthday", "");
                            }
                          }}
                          disabled={utils.disbaledInput}
                        />
                        {errors.dateOfBirthday && (
                          <div className="invalid-feedback d-block">
                            {errors.dateOfBirthday}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    {data.patient.account.id === 144 &&
                      data.source === "autoagendamientonuevoeps" && (
                        <Col xs="12" md="4">
                          <Form.Group>
                            <Form.Label className="fw-medium">
                              Tipo de plan *
                            </Form.Label>
                            <Select
                              options={options.tipoPlanOpt.map((it) => ({
                                value: it.id,
                                label: it.name,
                              }))}
                              value={
                                values.tipoPlan
                                  ? {
                                      value: values.tipoPlan,
                                      label: options.tipoPlanOpt.find(
                                        (it) => it.id === values.tipoPlan
                                      ).name,
                                    }
                                  : null
                              }
                              onChange={(value) => {
                                setFieldValue("tipoPlan", value?.value ?? "");
                              }}
                              placeholder="Selecciona una opción"
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  height: "34px",
                                  border: "1px solid #2A7EC3",
                                  boxShadow: 0,
                                  "&:hover": {
                                    borderColor: "#2A7EC3",
                                  },
                                }),
                              }}
                              isDisabled={utils.disbaledInput}
                            />
                            {errors.tipoPlan && (
                              <div className="invalid-feedback d-block">
                                {errors.tipoPlan}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                      )}
                    {data.patient.eps?.nombreEps !== "NUEVA EPS" &&
                      checkFieldValidation("eps", fieldSettings)?.visible && (
                        <Col xs="12" md="4">
                          <Form.Group>
                            <Form.Label className="fw-medium">
                              Entidad Promotora de Salud (EPS){" "}
                              {checkFieldValidation("eps", fieldSettings)
                                ?.required && "*"}
                            </Form.Label>
                            <Select
                              options={options.epsOpt.map((it) => ({
                                value: it.id,
                                label: it.nombreEps,
                              }))}
                              value={
                                values.eps
                                  ? {
                                      value: values.eps.id,
                                      label: values.eps.nombreEps,
                                    }
                                  : null
                              }
                              onChange={(value) => {
                                setFieldValue("eps.id", value.value);
                                setFieldValue("eps.nombreEps", value.label);
                              }}
                              placeholder="Selecciona una opción"
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  height: "34px",
                                  border: "1px solid #2A7EC3",
                                  boxShadow: 0,
                                  "&:hover": {
                                    borderColor: "#2A7EC3",
                                  },
                                }),
                              }}
                              isDisabled={
                                enableFieldConsulta
                                  ? false
                                  : utils.disbaledInput
                              }
                            />
                          </Form.Group>
                        </Col>
                      )}
                    {checkFieldValidation("bloodType", fieldSettings)
                      ?.visible && (
                      <Col xs="12" md="4">
                        <Form.Group>
                          <Form.Label className="fw-medium">
                            {t("Tiposangre")}{" "}
                            {checkFieldValidation("bloodType", fieldSettings)
                              ?.required && "*"}
                          </Form.Label>
                          <Select
                            options={options.tipoSangreOpt.map((it) => ({
                              value: it.id,
                              label: it.name,
                            }))}
                            value={
                              values.bloodType
                                ? {
                                    value: values.bloodType,
                                    label: options.tipoSangreOpt.find(
                                      (it) => it.id === values.bloodType
                                    ).name,
                                  }
                                : null
                            }
                            onChange={(value) => {
                              setFieldValue("bloodType", value.value ?? "");
                            }}
                            placeholder="Selecciona una opción"
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                height: "34px",
                                border: "1px solid #2A7EC3",
                                boxShadow: 0,
                                "&:hover": {
                                  borderColor: "#2A7EC3",
                                },
                              }),
                            }}
                            isDisabled={utils.disbaledInput}
                          />
                        </Form.Group>
                      </Col>
                    )}
                    {checkFieldValidation("nationality", fieldSettings)
                      ?.visible && (
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="fw-medium d-block">
                            {t("Nacionalidad")}{" "}
                            {checkFieldValidation("nationality", fieldSettings)
                              ?.required && "*"}
                          </Form.Label>
                          <label className="mr-5">
                            {t("colombiana")}
                            <Field
                              type="radio"
                              name="nationality"
                              value="Colombiana"
                              className="ml-3"
                              onChange={(e) => {
                                setFieldValue("nationality", "Colombiana");
                                let p = options.countryOpt.find(
                                  (el) => el.name.toLowerCase() === "colombia"
                                );
                                if (p) {
                                  setFieldValue("country.id", p.id);
                                  setFieldValue("country.name", p.name);
                                  setIdCountry(p.id);

                                  setFieldValue("countryBirth.id", p.id);
                                  setFieldValue("countryBirth.name", p.name);
                                }
                              }}
                              disabled={utils.disbaledInput}
                            />
                          </label>
                          <label className="mr-5">
                            {t("Extranjera")}
                            <Field
                              type="radio"
                              name="nationality"
                              value="Extranjera"
                              className="ml-3"
                              disabled={utils.disbaledInput}
                            />
                          </label>
                        </Form.Group>
                      </Col>
                    )}
                    {checkFieldValidation("countryBirth", fieldSettings)
                      ?.visible && (
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="fw-medium">
                            País de nacimiento{" "}
                            {checkFieldValidation("countryBirth", fieldSettings)
                              ?.required && "*"}
                          </Form.Label>
                          <Select
                            options={options.countryBirthOpt.map((it) => ({
                              value: it.id,
                              label: it.name,
                            }))}
                            value={
                              values.countryBirth?.id
                                ? {
                                    value: values.countryBirth.id,
                                    label: values.countryBirth.name,
                                  }
                                : null
                            }
                            onChange={(value) => {
                              setFieldValue(
                                "countryBirth.id",
                                value?.value ?? ""
                              );
                              setFieldValue(
                                "countryBirth.name",
                                value?.label ?? ""
                              );
                            }}
                            placeholder="Selecciona una opción"
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                height: "34px",
                                border: "1px solid #2A7EC3",
                                boxShadow: 0,
                                "&:hover": {
                                  borderColor: "#2A7EC3",
                                },
                              }),
                            }}
                            isDisabled={
                              utils.disbaledInput ||
                              values.nationality === "Colombiana"
                            }
                          />
                        </Form.Group>
                      </Col>
                    )}
                    {checkFieldValidation("country", fieldSettings)
                      ?.visible && (
                      <Col xs="12" md="4">
                        <Form.Group>
                          <Form.Label className="fw-medium">
                            País de residencia{" "}
                            {checkFieldValidation("country", fieldSettings)
                              ?.required && "*"}
                          </Form.Label>
                          <Select
                            options={options.countryOpt.map((it) => ({
                              value: it.id,
                              label: it.name,
                            }))}
                            value={
                              values.country?.id
                                ? {
                                    value: values.country.id,
                                    label: values.country.name,
                                  }
                                : null
                            }
                            onChange={(value) => {
                              setFieldValue("country.id", value?.value ?? "");
                              setFieldValue("country.name", value?.label ?? "");
                              //reset depto
                              setOptions((prev) => ({
                                ...prev,
                                municipioOpt: [],
                              }));
                              setFieldValue("municipio.id", "");
                              setFieldValue("municipio.dsMunDel", "");
                              setFieldValue("state.id", "");
                              setFieldValue("state.name", "");
                              setIdCountry(value.value);
                            }}
                            placeholder="Selecciona una opción"
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                height: "34px",
                                border: "1px solid #2A7EC3",
                                boxShadow: 0,
                                "&:hover": {
                                  borderColor: "#2A7EC3",
                                },
                              }),
                            }}
                            isDisabled={utils.disbaledInput}
                          />
                          {errors.country?.id && (
                            <div className="invalid-feedback d-block">
                              {errors.country.id}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    )}
                    <Col xs="12" md="4">
                      <Form.Group>
                        <Form.Label className="fw-medium">
                          {t("departamento")}
                        </Form.Label>
                        <Select
                          options={options.stateOpt.map((it) => ({
                            value: it.id,
                            label: it.name,
                          }))}
                          value={
                            values.state
                              ? {
                                  value: values.state.id,
                                  label: values.state.name,
                                }
                              : null
                          }
                          onChange={(value) => {
                            setFieldValue("state.id", value.value);
                            setFieldValue("state.name", value.label);

                            setFieldValue("municipio.id", "");
                            setFieldValue("municipio.dsMunDel", "");
                            setFieldValue("location", "");
                            setIdEstado(value.value);
                          }}
                          placeholder="Selecciona una opción"
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              height: "34px",
                              border: "1px solid #2A7EC3",
                              boxShadow: 0,
                              "&:hover": {
                                borderColor: "#2A7EC3",
                              },
                            }),
                          }}
                          isDisabled={utils.disbaledInput}
                        />
                        {errors.state?.id && (
                          <div className="invalid-feedback d-block">
                            {errors.state.id}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="4">
                      <Form.Group>
                        <Form.Label className="fw-medium">Ciudad</Form.Label>
                        <Select
                          options={options.municipioOpt.map((it) => ({
                            value: it.id,
                            label: it.dsMunDel,
                          }))}
                          value={
                            values.municipio
                              ? {
                                  value: values.municipio.id,
                                  label: values.municipio.dsMunDel,
                                }
                              : null
                          }
                          onChange={(value) => {
                            setFieldValue("municipio.id", value.value);
                            setFieldValue("municipio.dsMunDel", value.label);
                            if (value.value !== "2633") {
                              setFieldValue("location", "");
                            }
                          }}
                          placeholder="Selecciona una opción"
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              height: "34px",
                              border: "1px solid #2A7EC3",
                              boxShadow: 0,
                              "&:hover": {
                                borderColor: "#2A7EC3",
                              },
                            }),
                          }}
                          isDisabled={utils.disbaledInput}
                        />
                        {errors.municipio?.id && (
                          <div className="invalid-feedback d-block">
                            {errors.municipio.id}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12" md="4">
                      <Form.Group>
                        <Form.Label className="fw-medium">
                          Tipo de calle
                        </Form.Label>
                        <Select
                          options={options.roadTypeOpt.map((it) => ({
                            value: it.id,
                            label: it.name,
                          }))}
                          value={
                            values.colombusAddress?.roadType?.id
                              ? {
                                  value: values.colombusAddress.roadType.id,
                                  label: values.colombusAddress.roadType.name,
                                }
                              : null
                          }
                          onChange={(value) => {
                            setFieldValue(
                              "colombusAddress.roadType.id",
                              value?.value ?? ""
                            );
                            setFieldValue(
                              "colombusAddress.roadType.name",
                              value?.label ?? ""
                            );
                          }}
                          placeholder="Selecciona una opción"
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              height: "34px",
                              border: "1px solid #2A7EC3",
                              boxShadow: 0,
                              "&:hover": {
                                borderColor: "#2A7EC3",
                              },
                            }),
                          }}
                          isDisabled={utils.disbaledInput}
                        />
                        {errors.colombusAddress?.roadType?.id && (
                          <div className="invalid-feedback d-block">
                            {errors.colombusAddress?.roadType.id}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="4">
                      <Form.Group>
                        <Form.Label className="fw-medium opacity-0">
                          No
                        </Form.Label>
                        <Field
                          type="text"
                          className={`form-input ${
                            errors.colombusAddress?.streetField1 && "error"
                          }`}
                          name="colombusAddress.streetField1"
                          disabled={utils.disbaledInput}
                        />
                        {errors.colombusAddress?.streetField1 && (
                          <div className="invalid-feedback d-block">
                            {errors.colombusAddress.streetField1}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12" md="4">
                      <Form.Group>
                        <Form.Label className="fw-medium">Número </Form.Label>
                        <Field
                          type="text"
                          className={`form-input ${
                            errors.colombusAddress?.streetField2 && "error"
                          }`}
                          name="colombusAddress.streetField2"
                          disabled={utils.disbaledInput}
                        />
                        {errors.colombusAddress?.streetField2 && (
                          <div className="invalid-feedback d-block">
                            {errors.colombusAddress.streetField2}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="4">
                      <Form.Group>
                        <Form.Label className="fw-medium opacity-0">
                          Número{" "}
                        </Form.Label>
                        <Field
                          type="text"
                          className={`form-input ${
                            errors.colombusAddress?.streetField3 && "error"
                          }`}
                          name="colombusAddress.streetField3"
                          disabled={utils.disbaledInput}
                        />
                        {errors.colombusAddress?.streetField3 && (
                          <div className="invalid-feedback d-block">
                            {errors.colombusAddress.streetField3}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    {checkFieldValidation("localidad", fieldSettings)
                      ?.visible &&
                      values.municipio?.id === 2633 && (
                        <Col xs="12" md="4">
                          <Form.Group>
                            <Form.Label className="fw-medium">
                              {t("localidad")}{" "}
                              {checkFieldValidation("localidad", fieldSettings)
                                ?.required && "*"}
                            </Form.Label>
                            <Select
                              options={options.localidadOpt.map((it) => ({
                                value: it.id,
                                label: it.nombreLocalidad,
                              }))}
                              value={
                                values.localidad?.id
                                  ? {
                                      value: values.localidad.id,
                                      label: values.localidad.nombreLocalidad,
                                    }
                                  : null
                              }
                              onChange={(value) => {
                                setFieldValue("localidad.id", value.value);
                                setFieldValue(
                                  "localidad.nombreLocalidad",
                                  value.label
                                );
                              }}
                              placeholder="Selecciona una opción"
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  height: "34px",
                                  border: "1px solid #2A7EC3",
                                  boxShadow: 0,
                                  "&:hover": {
                                    borderColor: "#2A7EC3",
                                  },
                                }),
                              }}
                              isDisabled={utils.disbaledInput}
                            />
                            {errors.localidad?.id && (
                              <div className="invalid-feedback d-block">
                                {errors.localidad.id}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                      )}
                    {checkFieldValidation("neighborhood", fieldSettings)
                      ?.visible && (
                      <Col xs="12" md="4">
                        <Form.Group>
                          <Form.Label className="fw-medium">
                            {t("barrio")}{" "}
                            {checkFieldValidation("neighborhood", fieldSettings)
                              ?.required && "*"}{" "}
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-input`}
                            name="neighborhood"
                            disabled={utils.disbaledInput}
                          />
                        </Form.Group>
                      </Col>
                    )}

                    {checkFieldValidation("propertyType", fieldSettings)
                      ?.visible && (
                      <>
                        <Col xs="12" md="4">
                          <Form.Group>
                            <Form.Label className="fw-medium">
                              Tipo de Inmueble{" "}
                            </Form.Label>
                            <Select
                              options={options.propertyTypeOpt.map((it) => ({
                                value: it.id,
                                label: it.name,
                              }))}
                              value={
                                values.colombusAddress?.propertyType?.id
                                  ? {
                                      value:
                                        values.colombusAddress.propertyType.id,
                                      label:
                                        values.colombusAddress.propertyType
                                          .name,
                                    }
                                  : null
                              }
                              onChange={(value) => {
                                setFieldValue(
                                  "colombusAddress.propertyType.id",
                                  value?.value ?? ""
                                );
                                setFieldValue(
                                  "colombusAddress.propertyType.name",
                                  value?.label ?? ""
                                );
                              }}
                              placeholder="Selecciona una opción"
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  height: "34px",
                                  border: "1px solid #2A7EC3",
                                  boxShadow: 0,
                                  "&:hover": {
                                    borderColor: "#2A7EC3",
                                  },
                                }),
                              }}
                              isDisabled={utils.disbaledInput}
                            />
                            {errors.colombusAddress?.propertyType?.id && (
                              <div className="invalid-feedback d-block">
                                {errors.colombusAddress?.propertyType?.id}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                        <Col xs="12" md="4">
                          <Form.Group>
                            <Form.Label className="fw-medium">No </Form.Label>
                            <Field
                              type="text"
                              className={`form-input ${
                                errors.colombusAddress?.propertyType?.id &&
                                "error"
                              }`}
                              name="colombusAddress.unitNumber"
                              disabled={utils.disbaledInput}
                            />
                            {errors.colombusAddress?.propertyType?.id && (
                              <div className="invalid-feedback d-block">
                                {errors.colombusAddress?.propertyType?.id}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                      </>
                    )}

                    {checkFieldValidation(
                      "propertyTypeAdditional",
                      fieldSettings
                    )?.visible && (
                      <>
                        <Col xs="12" md="4">
                          <Form.Group>
                            <Form.Label className="fw-medium">
                              Bloque o Interior
                            </Form.Label>
                            <Select
                              options={options.propertyTypeOpt.map((it) => ({
                                value: it.id,
                                label: it.name,
                              }))}
                              value={
                                values.colombusAddress?.propertyTypeAdditional
                                  ?.id
                                  ? {
                                      value:
                                        values.colombusAddress
                                          .propertyTypeAdditional.id,
                                      label:
                                        values.colombusAddress
                                          .propertyTypeAdditional.name,
                                    }
                                  : null
                              }
                              onChange={(value) => {
                                setFieldValue(
                                  "colombusAddress.propertyTypeAdditional.id",
                                  value?.value ?? ""
                                );
                                setFieldValue(
                                  "colombusAddress.propertyTypeAdditional.name",
                                  value?.label ?? ""
                                );
                              }}
                              placeholder="Selecciona una opción"
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  height: "34px",
                                  border: "1px solid #2A7EC3",
                                  boxShadow: 0,
                                  "&:hover": {
                                    borderColor: "#2A7EC3",
                                  },
                                }),
                              }}
                              isDisabled={utils.disbaledInput}
                            />
                            {errors.colombusAddress?.propertyTypeAdditional
                              ?.id && (
                              <div className="invalid-feedback d-block">
                                {
                                  errors.colombusAddress?.propertyTypeAdditional
                                    .id
                                }
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                        <Col xs="12" md="4">
                          <Form.Group>
                            <Form.Label className="fw-medium">No </Form.Label>
                            <Field
                              type="text"
                              className={`form-input ${
                                errors.externalId && "error"
                              }`}
                              name="colombusAddress.propertyNumber"
                            />
                          </Form.Group>
                        </Col>
                      </>
                    )}
                  </Row>
                  <Row>
                    {checkFieldValidation("peso", fieldSettings)?.visible && (
                      <Col xs="12" md="4">
                        <Form.Group>
                          <Form.Label className="fw-medium">
                            {t("peso")} (Kg){" "}
                            {checkFieldValidation("peso", fieldSettings)
                              ?.required && "*"}{" "}
                          </Form.Label>
                          <Field
                            type="number"
                            className={`form-input ${errors.peso && "error"}`}
                            name="peso"
                            disabled={utils.disbaledInput}
                          />
                          {errors.peso && (
                            <div className="invalid-feedback d-block">
                              {errors.peso}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    )}
                    {checkFieldValidation("talla", fieldSettings)?.visible && (
                      <Col xs="12" md="4">
                        <Form.Group>
                          <Form.Label className="fw-medium">
                            {t("talla")} (cm){" "}
                            {checkFieldValidation("talla", fieldSettings)
                              ?.required && "*"}{" "}
                          </Form.Label>
                          <Field
                            type="number"
                            className={`form-input ${errors.talla && "error"}`}
                            name="talla"
                            disabled={utils.disbaledInput}
                          />
                          {errors.talla && (
                            <div className="invalid-feedback d-block">
                              {errors.talla}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col xs="12" md="12">
                      <Form.Group>
                        <Form.Label className="fw-medium">
                          {t("motivo_consulta")} *{" "}
                        </Form.Label>
                        <Field
                          as="textarea"
                          rows="3"
                          className={`form-input ${errors.sintomas && "error"}`}
                          name="sintomas"
                        />
                        {errors.sintomas && (
                          <div className="invalid-feedback d-block">
                            {errors.sintomas}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="12">
                      <Form.Group className="text-center">
                        <Field
                          type="checkbox"
                          className={`${
                            errors.aceptarTerminos && "error"
                          } mr-2`}
                          name="aceptarTerminos"
                        />
                        <Form.Label className="fw-medium">
                          {t("aceptar_term_cond_legales")}
                        </Form.Label>
                        {errors.aceptarTerminos && (
                          <div className="invalid-feedback d-block">
                            {errors.aceptarTerminos}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="12" className="text-center">
                      <button type="submit" className="mt-2 mb-4">
                        Continuar
                      </button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Card.Body>
        </Card>
      </Col>
      <Modal
        size="lg"
        show={utils.openAvisoLegal}
        onHide={() => setUtils((prev) => ({ ...prev, openAvisoLegal: false }))}
      >
        <Modal.Header closeButton>
          <h5>{t("aviso_legal_privacidad")}</h5>
        </Modal.Header>
        <Modal.Body>
          <p className="font-size-08rem">
            <label className="d-block text-uppercase">{t("aviso_legal")}</label>
            <strong>KOM CARE IPS S.A.S </strong> {t("aviso1")}
            <label className="d-block my-2">{t("aviso2")}</label>
            <label className="d-block">{t("resumen")}</label>
            {t("aviso3")} <br />
            <br />
            {t("aviso4")} <br />
            <br />
            {t("recabando_informacion")}
            <br />
            <strong>– {t("envio_voluntario")} –</strong>
            <br />
            {t("aviso5")}
            <br />
            <br />
            <strong>– {t("galleta_cookie")} –</strong>
            <br />
            {t("aviso6")}
            <br />
            <br />
            {t("aviso7")}.<br />
            <br />
            <strong>– {t("informacion_servidores")} –</strong>
            <br />
            {t("aviso8")}
            <br />
            <br />
            <strong>– {t("uso_informacion")} –</strong>
            <br />
            {t("aviso9")}.<br />
            <br />
            <strong>– {t("comunicacion_interactiva")} –</strong>
            <br />
            {t("aviso10")}
            <br />
            <br />
            {t("aviso11")} <br /> <br />
            <strong>– {t("comunicacion_terceras")} –</strong>
            <br />
            {t("aviso12")}
            <br />
            <br />
            <strong>– {t("control_informacion")} –</strong>
            <br />
            {t("aviso13")}
            <br />
            {t("derecho_autor")}
            <br />© {t("derecho_auto1")}
            <br />
            <br />
            {t("aviso14")}
            <br />
            {t("aviso15")}
            <br />
            <br />
            <strong>– {t("como_contactarnos")} –</strong>
            <br />
            {t("aviso16")}
            <br />
            <br />
            <strong>{t("aviso_privacidad")}</strong>
            <br />
            {t("aviso17")}
            <br />
            <br />
            {t("aviso18")}
            <br />
            {t("aviso19")}
            <br />
            {t("aviso20")}
            <br />
            {t("aviso21")}
            <br />
            {t("aviso22")}
          </p>
        </Modal.Body>
      </Modal>
      <Modal
        show={utils.openModalTitular}
        onHide={() =>
          setUtils((prev) => ({ ...prev, openModalTitular: false }))
        }
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <h6>Titular</h6>
        </Modal.Header>
        <Modal.Body>
          <Form.Label>
            Por favor indique el número de documento del titular de la póliza,
            con el fin de validar los datos y poder aprobar su cita
          </Form.Label>
          <Row className="mt-3">
            {utils.errorModalTitular && (
              <Col xs="12" md="12">
                <span className="text-danger">
                  Todos los campos son requeridos
                </span>
              </Col>
            )}
            <Col xs="12" md="12">
              <Form.Group>
                <Form.Label className="fw-medium">
                  {t("tipo_documento")}
                </Form.Label>
                <Select
                  options={options.tipoDocumentoOpt.map((it) => ({
                    label: `${it.code}: ${it.name}`,
                    value: it.id,
                    code: it.code,
                    name: it.name,
                  }))}
                  value={
                    utils.tipoDocumentModal?.id
                      ? {
                          label: `${utils.tipoDocumentModal.code}: ${utils.tipoDocumentModal.name}`,
                          value: utils.tipoDocumentModal.id,
                        }
                      : null
                  }
                  onChange={(value) => {
                    setUtils((prev) => ({
                      ...prev,
                      tipoDocumentModal: {
                        id: value?.value ?? "",
                        name: value?.name ?? "",
                        code: value?.code ?? "",
                      },
                    }));
                  }}
                  placeholder="Selecciona una opción"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      height: "34px",
                      border: "1px solid #2A7EC3",
                      boxShadow: 0,
                      "&:hover": {
                        borderColor: "#2A7EC3",
                      },
                    }),
                  }}
                />
              </Form.Group>
            </Col>
            <Col xs="12" md="12">
              <Form.Group>
                <Form.Label>{t("documento_identidad")}</Form.Label>
                <input
                  className="form-input"
                  value={utils.documentModal}
                  onChange={(e) =>
                    setUtils((prev) => ({
                      ...prev,
                      documentModal: e.target.value,
                    }))
                  }
                />
              </Form.Group>
            </Col>
            <Col xs="12" md="12" className="text-right">
              <button
                type="button"
                className="mt-2 mb-4"
                onClick={validarDocumento}
              >
                Validar
              </button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal
        show={utils.openModalEncontroTitular}
        onHide={() =>
          setUtils((prev) => ({ ...prev, openModalEncontroTitular: false }))
        }
        size="md"
        className="modalSuccessV2"
      >
        <Modal.Body className="px-5 py-3">
          <div>
            <p className="colorLabel fw-medium">{utils.textModalTitular}</p>
          </div>
        </Modal.Body>
      </Modal>
    </Row>
  );
};

export default ClbForm;
